import * as React from 'react';
import { Modal } from '@app/src/components/Modal';
import { FrameWrapper, FrameContent } from './styled';
import { useHistory } from 'react-router-dom';

export const Container = ({
  openModal,
  closeModal,
  reset,
  resetState,
  errorMessage
}) => {

  const history = useHistory();
  const handleCloseModal = () => {
    closeModal();
    reset();
    sessionStorage.clear();
    localStorage.clear();
    resetState();
    history.push('/');
  };

  return(
    <Modal
        openModal={openModal}
        closeModal={handleCloseModal}
      >
      {errorMessage ?
        <FrameWrapper>
          <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M24 0C10.6909 0 0 10.6909 0 24C0 37.3091 10.6909 48 24 48C37.3091 48 48 37.3091 48 24C48 10.6909 37.3091 0 24 0ZM24 43.6364C13.0909 43.6364 4.36364 34.9091 4.36364 24C4.36364 13.0909 13.0909 4.36364 24 4.36364C34.9091 4.36364 43.6364 13.0909 43.6364 24C43.6364 34.9091 34.9091 43.6364 24 43.6364Z" fill="#FF4D4D"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M32.0727 15.9273C31.2 15.0545 29.8909 15.0545 29.0182 15.9273L24 20.9454L18.9818 15.9273C18.1091 15.0545 16.8 15.0545 15.9273 15.9273C15.0545 16.8 15.0545 18.1091 15.9273 18.9818L20.9454 24L15.9273 29.0182C15.0545 29.8909 15.0545 31.2 15.9273 32.0727C16.3636 32.5091 16.8 32.7272 17.4545 32.7272C18.1091 32.7272 18.5454 32.5091 18.9818 32.0727L24 27.0545L29.0182 32.0727C29.4545 32.5091 30.1091 32.7272 30.5454 32.7272C30.9818 32.7272 31.6363 32.5091 32.0727 32.0727C32.9454 31.2 32.9454 29.8909 32.0727 29.0182L27.0545 24L32.0727 18.9818C32.9454 18.1091 32.9454 16.8 32.0727 15.9273Z" fill="#FF4D4D"/>
          </svg>
          <FrameContent>
            {errorMessage}
          </FrameContent>
        </FrameWrapper>
        :
        <FrameWrapper>
          <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M45.8337 23.0834V25C45.8311 29.4926 44.3764 33.8639 41.6864 37.4622C38.9965 41.0604 35.2155 43.6927 30.9073 44.9665C26.5991 46.2403 21.9946 46.0873 17.7805 44.5304C13.5663 42.9735 9.96836 40.0961 7.52316 36.3273C5.07796 32.5584 3.91656 28.1002 4.21215 23.6174C4.50775 19.1346 6.24451 14.8674 9.16341 11.4523C12.0823 8.03717 16.027 5.65709 20.4091 4.66701C24.7911 3.67694 29.3759 4.12991 33.4795 5.95838" stroke="#4EC853" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M45.8333 8.33337L25 29.1875L18.75 22.9375" stroke="#4EC853" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <FrameContent>
            Se modificó la contraseña de tu cuenta correctamente.
          </FrameContent>
        </FrameWrapper>
      }
    </Modal>
  );
};
